export const MAX_CARD_IMAGE_WIDTH = 381;
export const MAX_CARD_IMAGE_WIDTH_PX = `${MAX_CARD_IMAGE_WIDTH}px`;
